import { render, staticRenderFns } from "./GlobalSearchResults.vue?vue&type=template&id=01815574&"
import script from "./GlobalSearchResults.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports